/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <group-comment-list v-if="isGroup && !storeId"/>
    <store-comment-lists v-else/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GroupCommentList from './GroupCommentList'
  import StoreCommentLists from './StoreCommentLists'

  export default {
    name: 'GroupBankcardBus',
    components: { GroupCommentList, StoreCommentLists },
    computed: {
      ...mapGetters(['storeInfo','isGroup']),
      storeId() { return this.$route.query.store },
    }
  }
</script>
